import { Car } from "@/data/bruktbilsalgBackend/types/car.types";
import { Modal } from "@gnist/design-system";
import React from "react";
import { Specifications } from "@/app/bil/[carId]/components/specifications";
import { styled } from "styled-components";
import { tokens } from "@gnist/themes/tokens.css.js";

interface Props {
  car: Car;
  showSpecifications: boolean;
  setShowSpecifications: (x: boolean) => void;
}

const Wrapper = styled.div`
  margin-bottom: ${tokens.spacing["3xl"]};
`;

export const SpecificationsModal = ({
  car,
  showSpecifications,
  setShowSpecifications,
}: Props) => {
  return (
    <Modal
      isOpen={showSpecifications}
      handleClose={() => setShowSpecifications(false)}
      size={"fullscreen"}
      title="Spesifikasjoner"
    >
      <Wrapper>
        <Specifications car={car} />
      </Wrapper>
    </Modal>
  );
};
